module.exports = __webpack_public_path__ + "static/logo-gradient-62c073311fb26e826cc2137dc8321e04.svg";